<template>
  <div>
    <mdb-modal removeBackdrop size="sm" :show="modalShow" @close="handleClose" info>
      <mdb-modal-header>
        <mdb-modal-title>{{ title }}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>{{ description }}</mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn @click="handleOk" color="primary" size="sm">{{
          buttontext
        }}</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
} from "mdbvue";
export default {
  name: "SmallModal",
  props: {
    modalShow: Boolean,
    title: String,
    description: String,
    buttontext: String,
  },
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
  },
  methods: {
    handleOk() {
      this.$emit("modal-ok");
    },
    handleClose() {
      console.log("modal hide");
      this.$emit("modal-cancelled");
    },
  },
};
</script>